export { default } from './BorrowingQuotas';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingQuotas/index.js